import { dahuaAdapter } from './adapters/dahua';
import { hikvisionAdapter } from './adapters/hikvision';
import { streamaxAdapter } from './adapters/streamax';
import { VIDEO_VENDORS, getBroadcastDeviceId } from './vendors';
/**
 * Реестр фронтовых видеоадаптеров.
 * Новый вендор: src/video/adapters/<name>.ts, зарегистрировать здесь,
 * добавить provider в app/video/providers и ключ в VIDEO_VENDORS.
 */
const adapters = {
    [VIDEO_VENDORS.STREAMAX]: streamaxAdapter,
    [VIDEO_VENDORS.DAHUA]: dahuaAdapter,
    [VIDEO_VENDORS.HIKVISION]: hikvisionAdapter,
};
export function getVideoAdapter(vendor) {
    var _a;
    if (!vendor) {
        return null;
    }
    return (_a = adapters[vendor]) !== null && _a !== void 0 ? _a : null;
}
export function resolveVideoAdapter(broadcast) {
    if (broadcast === null || broadcast === void 0 ? void 0 : broadcast.vendor) {
        return getVideoAdapter(broadcast.vendor);
    }
    return getBroadcastDeviceId(broadcast) ? adapters[VIDEO_VENDORS.STREAMAX] : null;
}
